/* Luzzart · Home v5. Abas da vitrine (role="tablist", sem buscar nada: só alterna `hidden`) e acordeão com uma pergunta
   aberta por vez. Roda também no editor de temas (shopify:section:load). */
(function () {
  'use strict';

  function initTabs(root) {
    if (root.__lzhTabs) return;
    root.__lzhTabs = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var alls = Array.prototype.slice.call(root.querySelectorAll('[data-lzh-all]'));
    if (!tabs.length) return;

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      var href = tab.getAttribute('data-href');
      var label = tab.getAttribute('data-label');
      alls.forEach(function (a) {
        if (href) a.setAttribute('href', href);
        if (label) a.textContent = a.classList.contains('lzh-vit__more') ? label : label + ' →';
      });
      if (focus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') n = tabs[0];
        else if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  }

  function initFaq(root) {
    if (root.__lzhFaq) return;
    root.__lzhFaq = true;
    var items = Array.prototype.slice.call(root.querySelectorAll('details'));
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  function init(scope) {
    var s = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(s.querySelectorAll('[data-lzh-tabs]'), initTabs);
    Array.prototype.forEach.call(s.querySelectorAll('[data-lzh-faq]'), initFaq);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('lzh-tab')) t.click();
  });
})();
